import React, { useState, useEffect } from "react";
import { Accordion, Spinner, Form, InputGroup } from "react-bootstrap";
import { _get } from "../services/apiClient";
import { apiUrls } from "../config/apiUrls.const";

export default function Faq() {
  const [faqs, setFaqs] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchFaqs() {
      try {
        setLoading(true);
        // Assuming you have an endpoint for FAQs
        const response = await _get(apiUrls?.getFaqs || "/api/faqs");
        setFaqs(response.data || []);
      } catch (err: any) {
        setError(err.message || "Failed to load FAQs");
      } finally {
        setLoading(false);
      }
    }
    fetchFaqs();
  }, []);

  // Filter FAQs based on user typing
  const filteredFaqs = faqs.filter(faq => 
    faq.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
    faq.answer.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="container pb-5">
      {/* Matching your About Us Style */}
      <h1 className="page-header">Frequently Asked Questions</h1>
      <hr className="section-devider" />

      {/* Optional Search Bar */}
      <div className="row mb-4">
        <div className="col-md-6 mx-auto">
          <InputGroup>
            <InputGroup.Text id="search-icon">
              <i className="bi bi-search"></i>
            </InputGroup.Text>
            <Form.Control
              placeholder="Search for help..."
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </InputGroup>
        </div>
      </div>

      {loading && (
        <div className="text-center py-5">
          <Spinner animation="border" variant="primary" />
          <p className="mt-2">Loading Help Center...</p>
        </div>
      )}

      {error && <p className="text-danger text-center">{error}</p>}

      {!loading && !error && (
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <Accordion defaultActiveKey="0" flush className="faq-accordion">
              {filteredFaqs.length > 0 ? (
                filteredFaqs.map((faq, index) => (
                  <Accordion.Item eventKey={index.toString()} key={faq.id || index} className="mb-3 border rounded shadow-sm">
                    <Accordion.Header>
                      <span className="fw-bold text-secondary">{faq.question}</span>
                    </Accordion.Header>
                    <Accordion.Body className="text-muted">
                      {faq.answer}
                    </Accordion.Body>
                  </Accordion.Item>
                ))
              ) : (
                <p className="text-center py-4">No matching questions found.</p>
              )}
            </Accordion>
          </div>
        </div>
      )}

      {/* Footer Support Section */}
      <div className="mt-5 text-center p-4 bg-light rounded">
        <h5>Still have questions?</h5>
        <p className="text-muted">If you cannot find an answer in our FAQ, you can always contact us.</p>
        <button className="btn btn-primary px-4">Contact Support</button>
      </div>
    </div>
  );
}